import Datastore from "../datastore/Datastore";
import FeatureFlag from "./FeatureFlag";

export default class FeatureProvider {
    private datastore: Datastore;

    constructor(datastore: Datastore) {
        this.datastore = datastore;
    }

    getFeatureFlag(name: string): FeatureFlag {
        const featureFlagDict = this.datastore.getDict(name);
        return new FeatureFlag(name, featureFlagDict["value"]);
    }
}